module.exports = __webpack_public_path__ + "static/1.1.C. OLAR RANDARE 5-89e785463712dc8bc59e153107194b67.jpg";